import { render } from "./ModalFinalizarPrograma.vue?vue&type=template&id=80306854"
import script from "./ModalFinalizarPrograma.vue?vue&type=script&lang=js"
export * from "./ModalFinalizarPrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__